import { useEffect, useState } from "react";

interface GuestsPickerProps {
    guestsSlots?: number[]
    guests: number;
    setGuests: (value: number) => void;
    formColor: string;
    restaurantPhone?: string;
    isAutoSelectTable: boolean;
}

export const GuestsPicker: React.FC<GuestsPickerProps> = (props) => {
    const { guestsSlots, guests, setGuests, formColor, restaurantPhone, isAutoSelectTable } = props;

    const size = 6;
    const [internalGuestsSlots, setInternalGuestsSlots] = useState<string[][]>();
    const handleGuestClick = (inst: any) => {
        if (inst.target.innerHTML != '') {
            setGuests(inst.target.innerHTML);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const arr: string[][] = [];
        if (guestsSlots) {
            for (let i = 0; i < Math.ceil(guestsSlots.length / size); i++) {
                const intArr = [];
                for (let j = 0; j < size; j++) {
                    intArr.push(guestsSlots[i * size + j] ? guestsSlots[i * size + j].toString() : '');
                }
                arr.push(intArr);
            }
            setInternalGuestsSlots(arr);
        }
    }, [guestsSlots]);

    return (
        <div className={`picker__container`} >
            <div className='picker__slide'>
                {internalGuestsSlots?.length == 0 && (
                    <h3 className="picker__noentries">На выбранный день отсутствуют свободные столики в системе, но ресторан открыт - попробуйте туда позвонить</h3>
                )}
                Число гостей
                {internalGuestsSlots?.map((element, index) => {
                    return (
                        <div key={'r' + index} className="picker__row">
                            {element.map((childElement, childIndex) => {
                                return (
                                    <div
                                        style={guests.toString() == childElement ? { backgroundColor: formColor } : {}}
                                        key={'e' + childIndex}
                                        id={'e' + (index * 7 + childIndex)}
                                        role="presentation"
                                        onClick={handleGuestClick}
                                        className={`picker__element picker__element_time${guests.toString() == childElement ? ' picker__element_selected' : ''}${childElement == '' ? ' picker__element_empty' : ''}`}>
                                        {childElement}
                                    </div>);
                            })}

                        </div>
                    );
                })}
                {(restaurantPhone != undefined && restaurantPhone != "Укажите номер") &&
                    <div style={{ marginTop: 10,  lineHeight: 1.5}}>
                        {isAutoSelectTable ? 
                        "Представлены имеющиеся варианты при посадке за один столик. Вы можете позвонить в ресторан и забронировать несколько столов на компанию по номеру " 
                        : 
                        "О возможности забронировать столы на большее число гостей уточните по телефону "}
                        <a className="picker__href" href={`tel:${restaurantPhone}`}>{restaurantPhone}</a>
                    </div>
                }
            </div>
        </div>);
}